// pick-your-games.js
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.top-games-section');

  sections.forEach(section => {
    const grid = section.querySelector('.games-grid');
    if (!grid) return;

    const cards = grid.querySelectorAll('.game-card');
    const totalCards = cards.length;

    let perPage = window.innerWidth <= 1200 ? 8 : 15;
    let totalPages = Math.ceil(totalCards / perPage);
    let currentPage = 1;

    function getButtons() {
      const isMobile = window.innerWidth <= 1200;
      const prevBtn = section.querySelector(
        isMobile
          ? '.prev-next-btns-mobile .pick-your-games-prev-btn'
          : '.prev-next-btns-desktop .pick-your-games-prev-btn'
      );
      const nextBtn = section.querySelector(
        isMobile
          ? '.prev-next-btns-mobile .pick-your-games-next-btn'
          : '.prev-next-btns-desktop .pick-your-games-next-btn'
      );
      return { prevBtn, nextBtn };
    }

    let { prevBtn, nextBtn } = getButtons();
    if (!prevBtn || !nextBtn) return;

    function updateDisplay() {
      const start = (currentPage - 1) * perPage;
      const end = start + perPage;

      cards.forEach((card, index) => {
        card.style.display = (index >= start && index < end) ? '' : 'none';
      });

      if (prevBtn) prevBtn.disabled = currentPage === 1;
      if (nextBtn) {
        nextBtn.disabled = currentPage === totalPages;
        if (currentPage < totalPages) {
          nextBtn.classList.add('has-more');
        } else {
          nextBtn.classList.remove('has-more');
        }
      }
    }

    function changePage(direction) {
      currentPage += direction;
      if (currentPage < 1) currentPage = 1;
      if (currentPage > totalPages) currentPage = totalPages;

      updateDisplay();

      // Bigger offset so the grid is fully visible below your sticky header
      const headerOffset = window.innerWidth <= 768 ? 140 : 200;
      // ↑ adjust these numbers until it feels right for mobile/desktop

      const gridTop = grid.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: gridTop,
        behavior: 'smooth'
      });
    }

    // Reusable handlers (so removeEventListener works)
    const handlePrevClick = () => changePage(-1);
    const handleNextClick = () => changePage(1);

    // Attach initial listeners
    prevBtn.addEventListener('click', handlePrevClick);
    nextBtn.addEventListener('click', handleNextClick);

    // Initial display
    updateDisplay();

    // Handle window resize: update perPage, buttons, and listeners
    window.addEventListener('resize', () => {
      const oldPerPage = perPage;
      const oldPrevBtn = prevBtn;
      const oldNextBtn = nextBtn;

      perPage = window.innerWidth <= 1200 ? 8 : 15;
      totalPages = Math.ceil(totalCards / perPage);

      const { prevBtn: newPrevBtn, nextBtn: newNextBtn } = getButtons();

      const buttonsChanged = newPrevBtn !== oldPrevBtn || newNextBtn !== oldNextBtn;
      const perPageChanged = perPage !== oldPerPage;

      if (buttonsChanged || perPageChanged) {
        // Remove listeners from old buttons
        if (oldPrevBtn) oldPrevBtn.removeEventListener('click', handlePrevClick);
        if (oldNextBtn) oldNextBtn.removeEventListener('click', handleNextClick);

        // Update button references
        prevBtn = newPrevBtn;
        nextBtn = newNextBtn;

        // Attach listeners to new buttons (if they exist)
        if (prevBtn) prevBtn.addEventListener('click', handlePrevClick);
        if (nextBtn) nextBtn.addEventListener('click', handleNextClick);

        // Reset to first page on layout change
        currentPage = 1;
        updateDisplay();
      }
    });
  });
});